// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newciis {
  font-family: Montserrat;
}

.excelimg {
  margin-right: 4px;
  height: 15px;
}

.btn-outline-primary-custom {
  color: #17a0b4 !important;
  background-image: none !important;
  background-color: transparent !important;
  border-color: #17a0b4 !important;
}

.intheader {
  font-size: 14px;
  padding-left: 2%;
}

.headercard {
  height: 34px;
  border-radius: 2px;
}

.newintbtndiv {
  padding-left: 6%;
}

.addicon {
  font-size: 19px;
  height: -moz-fit-content;
  height: fit-content;
}

.searchcard {
  border-radius: 2px;
  background-color: #ebebeb;
  font-size: 11px;
}

.proclabel {
  padding-left: 10%;
}

.dircfieldcol {
  padding-right: 24px;
}

.btnsrcexp {
  margin-top: 0%;
  padding-inline: 20%;
  margin-left: -17%;
  height: 27px !important;
}

.targetlabel {
  padding-left: 10%;
}

.targetfieldcol {
  padding-right: 24px;
}

.projlabeltrue {
  padding-left: 12%;
}

.projfielddiv {
  padding-right: 15px;
}

.listcard {
  border-radius: 2px;
}

.todaylabel {
  height: 26px;
}

.todaydivider {
  background-color: rgb(10, 87, 117);
  height: 1px;
}

.yestlabel {
  height: 28px;
}

.todayssuccessdivider {
  background-color: green;
  height: 1px;
}

.todaysinprogdivider {
  background-color: #73731d;
  height: 1px;
}

.todaysfaildivider {
  background-color: #4e0c0c;
  height: 1px;
}

.desentity {
  padding-left: 53px;
}

.modebtn {
  height: 17px !important;
  line-height: 9px;
}

.pendingbtn {
  height: 23px;
}

.pendingfileicon {
  font-size: 18px;
  line-height: 14px;
  padding-right: 6px;
  height: auto;
}

.pendingdate {
  padding-top: 1px;
}

.pendingcount {
  padding-right: 1px;
  background-color: #ffd965;
  color: white;
  border-radius: 12px;
}

.pendingcountfail {
  padding-right: 1px;
  background-color: red;
  color: white;
  border-radius: 12px;
}

.checklistdiv {
  width: 90%;
}

.targetidslabel {
  padding-left: 8%;
}

.vendorconlabel {
  padding-left: 98px;
}

::ng-deep.failuremsgpop .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.failuremsgpop {
  top: 4% !important;
}

.btn_stylenewint {
  padding: 2px;
  background-color: #00b050 !important;
  font-size: 12px !important;
  color: white !important;
  height: 25px !important;
  border-radius: 1px;
  width: 100%;
  cursor: pointer;
}

.btn_stylereset {
  padding: 2px;
  background-color: #ebebeb !important;
  font-size: 12px !important;
  color: black !important;
  height: 25px !important;
  border-radius: 1px;
  width: 100%;
  cursor: pointer;
}

.statusdiv {
  padding-left: 4px;
}

::ng-deep .pipeline_feild .autocomplete-container {
  box-shadow: none !important;
  border-radius: 5px !important;
}
::ng-deep .pipeline_feild .autocomplete-container .input-container input {
  border: 1px solid #C0C0C0 !important;
  height: 28px !important;
  width: 100% !important;
}
::ng-deep .pipeline_feild .autocomplete-container .input-container i {
  line-height: 12px !important;
}
::ng-deep .pipeline_feild .autocomplete-container .suggestions-container ul li a {
  padding: 7px 13px !important;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.datediv {
  border: 1px solid #C0C0C0;
  background-color: white;
  border-radius: 5px;
  height: 28px;
}

.datediv2 {
  border: 1px solid #C0C0C0;
  background-color: white;
  border-radius: 5px;
  height: 28px;
  width: 99%;
  margin-left: 4px;
}

.fromspan {
  padding-right: 6px;
  padding-left: 9px;
  font-size: 11px;
}

.frominput {
  border: transparent;
  font-size: 12px;
}

.tospan {
  padding-right: 3%;
  font-size: 11px;
}

.tospanfail {
  font-size: 11px;
  padding-right: 1% !important;
}

.toinput {
  border: transparent;
  font-size: 12px;
}

.searchbtn {
  margin-top: 7px;
  width: 5%;
  height: 26px !important;
}

.searchicon {
  font-size: 16px !important;
  line-height: 20px !important;
}

.searchdiv {
  display: contents;
}

.leftcol {
  background-color: #f2f2f2;
  height: 84vh;
}

.status {
  width: 100%;
  border-radius: 5px;
  height: 26px;
  font-size: 12px;
  font-family: Montserrat;
}

.direction {
  width: 100%;
  border-radius: 5px;
  height: 28px;
  font-size: 12px;
  border: 1px solid #C0C0C0;
  font-family: Montserrat;
}
.direction option {
  font-family: Montserrat;
  padding: 7px 13px !important;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.dateselect {
  width: 100%;
  border-radius: 5px;
  height: 28px;
  font-size: 12px;
  border: 1px solid #C0C0C0;
  font-family: Montserrat;
  background-color: #007887;
  color: white;
}
.dateselect option {
  font-family: Montserrat;
  padding: 7px 13px !important;
  background-color: white;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.dateselect2 {
  width: 80%;
  border-radius: 5px;
  height: 28px;
  font-size: 12px;
  border: 1px solid #C0C0C0;
  font-family: Montserrat;
  background-color: #007887;
  color: white;
  margin-left: 24px !important;
}
.dateselect2 option {
  font-family: Montserrat;
  padding: 7px 13px !important;
  background-color: white;
  display: block !important;
  text-decoration: none !important;
  cursor: pointer !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 12px !important;
}

.rightcol {
  background-color: white;
  font-size: 12px;
}

.active_card {
  border-left: 4px solid #07a36e;
  width: 99%;
}

.active_cardcolor {
  border-left: 4px solid #07a36e;
  width: 99%;
  background-color: #C3EFF4;
}

.failed_card {
  border-left: 4px solid #da606c;
  width: 99%;
}

.failed_cardcolor {
  border-left: 4px solid #da606c;
  width: 99%;
  background-color: #C3EFF4;
}

.active_img_inbound {
  display: none;
}

.active_img {
  display: none;
}

.inactive_img {
  display: block;
  margin-right: 9px;
  position: relative;
  top: -2px;
}

.inactive_img_inbound {
  display: block;
  margin-right: 11px;
  position: relative;
  top: -2px;
}

.displayNamediv {
  padding-left: 6px;
}

.pipelinenamediv:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white !important;
  padding: 3px !important;
  cursor: pointer;
}

.assignedUserNamediv:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white !important;
  padding: 4px !important;
}

.modediv {
  padding-left: 8px;
}

.routeIDdiv {
  padding-left: 6px;
}

.transcountcol {
  padding-inline: 7px;
}

.transcountsuccess {
  background-color: rgba(125, 251, 147, 0.2509803922);
  padding-block: 1px;
  border: 1px solid rgba(0, 128, 0, 0.4901960784);
  font-size: 12px;
}

.transcountinprogress {
  background-color: rgba(253, 242, 102, 0.3490196078);
  padding-block: 1px;
  border: 1px solid #989024;
  font-size: 12px;
}

.transcountfailedto {
  background-color: rgba(255, 128, 128, 0.3019607843);
  padding-block: 1px;
  border: 1px solid rgba(111, 15, 15, 0.6117647059);
  font-size: 12px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.transcountfailedyes {
  background-color: rgba(255, 128, 128, 0.3019607843);
  padding-block: 1px;
  border: 1px solid rgba(111, 15, 15, 0.6117647059);
  font-size: 12px;
  border-bottom-right-radius: 5px;
}

.detailsrouteid {
  border-right: 2px solid #00bcd4;
}

.agents {
  border-right: 2px solid #00bcd4;
}

.datesdiv {
  background-color: #ebebeb;
}

.datedivsize {
  width: 21%;
  padding-left: 31px;
}

.datedivsizemod {
  width: 21%;
  padding-left: 6%;
}

.transadiv {
  color: #17a0b4;
  font-size: 12px;
  margin-top: 3px;
}

.countdate {
  font-size: 12px;
  margin-left: 103px;
}

.countdatediv {
  width: 100px;
  text-align: center;
  border: 1px solid #e6e6e6;
  cursor: pointer;
  text-decoration: underline;
  padding: 15px;
  background-color: #ebebeb;
}

.successmsgheaders {
  width: 100.3px;
  text-align: center;
  border: 1px solid #e6e6e6;
  padding: 15px;
  background-color: #ebebeb;
  font-size: 12px;
}

.msgtitle {
  font-size: 12px;
  width: 100px;
  border: 1px solid #e6e6e6;
  text-align: left;
  padding: 15px;
}

.msgcountdiv {
  width: 100px;
  text-align: center;
  border: 1px solid #e6e6e6;
  padding: 15px;
}

::ng-deep.directiontabs .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #17a0b4 !important;
  height: 4px !important;
  margin-left: auto;
}

::ng-deep.directiontabs .mat-tab-header {
  height: 33px;
}

::ng-deep.directiontabs .mat-tab-label {
  height: 31px !important;
  text-transform: uppercase;
}

::ng-deep.directiontabs .mat-tab-label .mat-tab-label-content {
  font-size: 12px !important;
  font-weight: 600 !important;
}

::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #17a0b4 !important;
  background-color: white !important;
  opacity: unset !important;
  font-family: Montserrat;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .active_img {
  display: block !important;
  margin-right: 9px;
  position: relative;
  top: -2px;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .inactive_img {
  display: none !important;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .active_img_inbound {
  display: block !important;
  margin-right: 11px;
  position: relative;
  top: -2px;
}
::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .inactive_img_inbound {
  display: none !important;
}

.directionlist {
  font-size: 11px;
  font-family: Montserrat;
  min-height: 66vh !important;
  max-height: 66vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.directionlistexp {
  font-size: 11px;
  font-family: Montserrat;
  min-height: 47vh !important;
  max-height: 47vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.dedisplayname {
  color: #17a0b4;
  font-weight: bold;
  border-right: 2px solid #00bcd4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dividerline {
  background-color: #17a0b4;
  height: 3px;
  width: 100%;
  margin-top: 10px;
}

.highchart {
  border: 2px solid #007887;
  font-size: 12px;
  min-height: 280px;
  max-height: 280px;
  margin-left: 4%;
}

.highcharts-figure,
.highcharts-data-table table {
  min-width: 310px;
  max-width: 310px;
  margin: 1em auto;
}

#container {
  height: 200px;
}

.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
  max-width: 300px;
}

.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}

.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}

.highcharts-data-table tr:hover {
  background: #f1f7ff;
}

.failresbody {
  min-height: 255px;
  max-height: 255px;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

.failrestitle {
  font-size: 12px;
  color: white;
  border-radius: 2px;
}

.failres {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline;
  cursor: pointer;
}

.failresdiv {
  margin-left: 25px;
  padding-right: 33px;
}

.lockicon {
  font-size: 18px;
  color: #ff5d00;
  height: auto;
}

.ids {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 4%;
}

.vendorids {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 35%;
}

.vendoridsmail {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 34px;
}

.vendoridsph {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 4%;
}

.vendormaillabel {
  padding-left: 8%;
}

.idspop {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 36%;
  padding-left: 1%;
}

.idsproc {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 42%;
  padding-left: 40px;
  padding-right: 80px;
}

.idsproj {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 42%;
  padding-left: 7%;
}

.idslab {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 38%;
  padding-left: 77px;
  padding-right: 6%;
}

.pipelineidsdiv {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 38%;
  padding-right: 6%;
  padding-left: 54px;
}

.idsfac {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-family: Montserrat;
  width: 34%;
  padding-left: 26px;
}

.projlabel {
  padding-left: 28px;
}

.fontcolr {
  color: #17a0b4;
}

.failresbodypop {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  min-height: 350px;
  max-height: 350px;
}

.successresbody {
  min-height: 255px;
  max-height: 255px;
  border-bottom: 2px solid #007887;
  border-left: 2px solid #007887;
  border-right: 2px solid #007887;
  border-radius: 2px;
}

.successreslist {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  min-height: 232px;
  max-height: 232px;
}

.failurelistheader {
  background-color: #007887;
  font-size: 12px;
  color: white;
  font-family: Montserrat;
}

::ng-deep.failresbodypop .mat-checkbox-frame {
  border: 1px solid #007887;
}

::ng-deep.failresbodypop .mat-checkbox-inner-container {
  height: 15px;
}

::ng-deep.failurelistheader .mat-checkbox-frame {
  border: 1px solid #007887;
}

::ng-deep.failurelistheader .mat-checkbox-inner-container {
  height: 15px;
  background-color: white;
}

.reprobtn {
  background-color: #007887;
  font-size: 12px;
  color: white;
  font-family: Montserrat;
  cursor: pointer;
}

.popupdate {
  border-left: 2px solid #00bcd4;
  border-right: 2px solid #00bcd4;
}

.reason {
  font-size: 13px;
  color: #17a0b4;
  font-weight: bold;
  font-family: Montserrat;
}

.headercheckbox {
  padding-left: calc(1vw + 3px);
}

.chevronleft {
  line-height: 36px;
  top: 14px;
  position: relative;
}

.chevronleftbtnact {
  background-color: green;
  color: white;
  margin-left: 1%;
}

.chevronleftbtninact {
  background-color: red;
  color: white;
  margin-left: 1%;
}

.failresheader {
  background-color: #007887;
}

.countdateheader {
  background-color: #007887;
  height: 22px;
  width: 100%;
  margin-left: 0px;
}

.modal .modalsize {
  max-width: 90% !important;
}

::ng-deep.idsexpdiv .idsacc .mat-expansion-panel-body {
  padding: 5px !important;
  background-color: #ebebeb !important;
  font-size: 12px;
}

.msgcountday {
  background-color: #17a2b8;
  color: white;
}

.main {
  height: 17px;
  border-radius: 0 0 100px 100px;
  border: 1px solid grey;
  border-top: none;
  background-clip: padding-box;
  position: relative;
  display: inline-block;
  margin-right: 6px;
  padding-inline: 3px;
  position: relative;
  top: 9px;
}

.submain {
  height: 17px;
  border-radius: 0 0 100px 100px;
  border: 1px solid grey;
  border-top: none;
  background-clip: padding-box;
  position: relative;
  display: inline-block;
  margin-right: 6px;
  padding-inline: 3px;
  position: relative;
  top: 9px;
}

.main::after {
  content: "";
  position: absolute;
  left: 100%;
  right: 1px;
  height: 1px;
  border-top: 1px solid grey;
  width: 33%;
  display: inline;
  top: 0;
}

.img_space {
  height: 23px;
  position: relative;
  top: -12px;
}

.varulebtn {
  height: 23px !important;
}

.connheadersdef {
  bottom: 7%;
  position: relative;
  background-color: #ebebeb;
  color: black;
  border: 1px solid;
  border-radius: 1px;
  left: 14%;
  width: 70%;
}

.details2 {
  background-color: white;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  min-height: 64vh;
  max-height: 64vh;
}

::ng-deep.connec .mat-tab-label {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
}

::ng-deep.interface .Failed {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
  background-color: red;
  color: white;
}

::ng-deep.connec .Success.mat-tab-label {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
  background-color: green !important;
  color: white !important;
}

::ng-deep.connec .default .mat-tab-label {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border-right: 2px solid #ebebeb !important;
}

::ng-deep.connec .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #17a0b4 !important;
  height: 4px !important;
  margin-left: auto;
}

.stepper-wrapper {
  display: flex;
  justify-content: space-between;
  height: 82vh;
  overflow-x: hidden;
}

.stepper-item {
  position: relative;
  font-size: 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  background-color: #ebebeb;
  border: 2px solid rgba(200, 197, 197, 0.2196078431);
  min-width: 16.66%;
  max-width: 16.66%;
}

.cursor {
  cursor: pointer;
}

.seqheader {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border: 2px solid #ebebeb !important;
  height: 33px;
  padding: 5px;
  text-align: center;
  opacity: 0.5;
}

.seqheaderActive {
  opacity: unset;
  box-shadow: 1px 0px 7px 1px grey;
}

.Failed {
  background-color: #f59598 !important;
  color: white !important;
}

.Success {
  background-color: #90cfb5 !important;
  color: white !important;
}

.default {
  min-width: 16.66% !important;
  max-width: 16.66% !important;
  border: 2px solid #ebebeb !important;
  height: 33px;
  padding: 5px;
  text-align: center;
  opacity: 0.5;
}

.seqbody {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  min-height: 120px;
  max-height: 120px;
  background-color: rgba(169, 218, 209, 0.3215686275);
}

.datediviconsize {
  padding-left: 4%;
  width: 14%;
}

.form-control {
  border-radius: 5px !important;
  font-size: 11px !important;
}

.failurelistheader1 {
  font-size: 12px;
  color: black;
  font-family: Montserrat;
}

.mat-mdc-table {
  width: 100%;
  max-height: 100px;
  overflow: auto;
}

.mat-column-name {
  height: 100px;
}

.datavalidtableheader {
  position: sticky;
  top: 0;
  background-color: #0e6470;
  z-index: 1;
  color: white;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-row {
  margin-top: 30px; /* Adjust the margin as needed */
}

.even-row {
  background-color: #F0F0F0;
}

.odd-row {
  background-color: #FFFFFF;
}

.even-row,
.odd-row {
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

.mat-form-field-appearance-outline .mat-form-field-infix {
  width: 221px;
}

.callsplit {
  margin-right: 5px;
  color: #f44455;
}

.scrollable-content {
  position: absolute;
  top: 20px; /* Adjust this value to match the height of the sticky row */
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
}

::ng-deep .ValidationPopupScreen .modal-dialog {
  max-width: 80%;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

.Header_row {
  background: #007887;
  margin-inline: -0.5px;
  color: white;
}

/* Add the styles for the scrolling div */
.card-scroll {
  height: 387px; /* Adjust the height as needed */
  overflow-x: hidden;
}

.selected {
  background-color: #B8FAFF; /* Add your desired background color for the selected card */
}

.isCompletedStatus {
  cursor: pointer;
}

.visibility_off {
  color: #17a2b8;
  height: 19px !important;
  width: 19px !important;
  font-size: 19px;
  padding-left: 13px;
  position: relative;
  top: 1px;
  cursor: pointer;
}

.visibility {
  color: #17a2b8;
  height: 19px !important;
  width: 19px !important;
  font-size: 19px;
  cursor: pointer;
}

.failrow .msgtitle {
  background-color: #ffc3c3;
}

.failrow .msgcountdiv {
  background-color: #ffc3c3;
}

.ignorerow .msgtitle {
  background-color: #fffdbe;
}

.ignorerow .msgcountdiv {
  background-color: #fffdbe;
}

.successrow .msgtitle {
  background-color: #c4fba0;
}

.successrow .msgcountdiv {
  background-color: #c4fba0;
}

.resolvedrow .msgtitle {
  background-color: #c6ecff;
}

.resolvedrow .msgcountdiv {
  background-color: #c6ecff;
}

.datedivpop {
  border: 1px solid #C0C0C0;
  background-color: white;
  border-radius: 5px;
  height: 24px;
  width: 47%;
}

.toinputpop {
  border: transparent;
  font-size: 12px;
  height: 20px;
}

.frominputpop {
  border: transparent;
  font-size: 12px;
  height: 20px;
}

.datesearchpopbtn {
  background-color: #59a7b1;
  color: white;
  height: 24px;
  width: 28px;
  padding-left: 1px;
}

.copy_iconss {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  font-size: 16px;
  position: relative;
  top: 8%;
  left: 2%;
  cursor: pointer;
}

.mat-icon-button ::ng-deep .mat-button-focus-overlay {
  display: none;
}

::ng-deep.myint.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 100%;
  bottom: 42%;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox {
  width: 14px;
  height: 14px;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.myint.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

.msgmodaldata {
  min-height: 65vh !important;
  max-height: 68vh !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

::ng-deep.moreicon .mat-mdc-button-persistent-ripple {
  display: none !important;
}

.autocomplete-dropdown {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  border-radius: 6px !important;
}

.autocomplete-dropdown ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  color: black;
}

.autocomplete-dropdown li {
  padding: 8px;
  cursor: pointer;
}

.autocomplete-dropdown li:hover {
  background-color: #f0f0f0;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.loading-spinner {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

.mat-spinner {
  width: 20px;
  height: 20px;
}

.clear-icon {
  position: absolute;
  right: 0%;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
  top: 20%;
  font-size: 18px !important;
}

.redirectlink:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white;
  padding: 3px;
  cursor: pointer;
  height: 21px;
}

.interfacepagination .mat-mdc-paginator {
  background-color: #f1f1f1 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/CIIS/interface/interface.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,uBAAA;AADJ;;AAGA;EACE,iBAAA;EAAkB,YAAA;AACpB;;AACA;EACE,yBAAA;EACA,iCAAA;EACA,wCAAA;EACA,gCAAA;AAEF;;AAAA;EACE,eAAA;EAAgB,gBAAA;AAIlB;;AAFA;EACE,YAAA;EAAa,kBAAA;AAMf;;AAJA;EACE,gBAAA;AAOF;;AALA;EACE,eAAA;EAAgB,wBAAA;EAAA,mBAAA;AASlB;;AAPA;EACE,kBAAA;EAAqB,yBAAA;EAA0B,eAAA;AAYjD;;AAVA;EACE,iBAAA;AAaF;;AAXA;EACE,mBAAA;AAcF;;AAZA;EACE,cAAA;EAAe,mBAAA;EAAoB,iBAAA;EAAkB,uBAAA;AAkBvD;;AAhBA;EACE,iBAAA;AAmBF;;AAjBA;EACE,mBAAA;AAoBF;;AAlBA;EACE,iBAAA;AAqBF;;AAlBA;EACE,mBAAA;AAqBF;;AAnBA;EACE,kBAAA;AAsBF;;AApBA;EACE,YAAA;AAuBF;;AArBA;EACE,kCAAA;EAAiC,WAAA;AAyBnC;;AAvBA;EACE,YAAA;AA0BF;;AAxBA;EACE,uBAAA;EAAwB,WAAA;AA4B1B;;AA1BA;EACE,yBAAA;EAA0B,WAAA;AA8B5B;;AA5BA;EACE,yBAAA;EAA0B,WAAA;AAgC5B;;AA9BA;EACE,kBAAA;AAiCF;;AA/BA;EACE,uBAAA;EAAwB,gBAAA;AAmC1B;;AAjCA;EACE,YAAA;AAoCF;;AAlCA;EACE,eAAA;EAAgB,iBAAA;EAAkB,kBAAA;EAAmB,YAAA;AAwCvD;;AAtCA;EACE,gBAAA;AAyCF;;AAvCA;EACE,kBAAA;EAAmB,yBAAA;EAA0B,YAAA;EAAa,mBAAA;AA6C5D;;AA3CA;EACE,kBAAA;EAAmB,qBAAA;EAAqB,YAAA;EAAa,mBAAA;AAiDvD;;AA/CA;EACE,UAAA;AAkDF;;AAhDA;EACE,gBAAA;AAmDF;;AAhDA;EACE,kBAAA;AAmDF;;AA/CA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAkDF;;AAhDA;EACE,kBAAA;AAmDF;;AAjDA;EACE,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAoDF;;AAlDA;EACE,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAqDF;;AAnDA;EACE,iBAAA;AAsDF;;AApDA;EACI,2BAAA;EACA,6BAAA;AAuDJ;AAtDI;EACI,oCAAA;EACA,uBAAA;EACA,sBAAA;AAwDR;AAtDI;EACI,4BAAA;AAwDR;AArDI;EACI,4BAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAuDR;;AAnDA;EACI,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AAsDJ;;AApDA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAuDF;;AArDA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAwDA;;AAtDA;EACA,mBAAA;EACA,eAAA;AAyDA;;AAvDA;EACI,iBAAA;EACA,eAAA;AA0DJ;;AAxDA;EACE,eAAA;EACA,4BAAA;AA2DF;;AAzDA;EACA,mBAAA;EACA,eAAA;AA4DA;;AA1DA;EACI,eAAA;EACA,SAAA;EACA,uBAAA;AA6DJ;;AA3DA;EACI,0BAAA;EACA,4BAAA;AA8DJ;;AA5DA;EACI,iBAAA;AA+DJ;;AA7DA;EACA,yBAAA;EACA,YAAA;AAgEA;;AA9DA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AAiEJ;;AA/DA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;AAkEF;AAjEE;EACE,uBAAA;EACE,4BAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAmEN;;AAhEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAmEF;AAlEE;EACE,uBAAA;EACE,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAoEN;;AAjEA;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;AAoEF;AAnEE;EACE,uBAAA;EACE,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;AAqEN;;AAlEI;EACA,uBAAA;EACA,eAAA;AAqEJ;;AAnEI;EACE,8BAAA;EACA,UAAA;AAsEN;;AApEI;EACE,8BAAA;EACA,UAAA;EAAW,yBAAA;AAwEjB;;AAtEI;EACE,8BAAA;EACA,UAAA;AAyEN;;AAvEI;EACE,8BAAA;EACA,UAAA;EAAW,yBAAA;AA2EjB;;AAzEA;EACE,aAAA;AA4EF;;AA1EA;EACE,aAAA;AA6EF;;AA3EA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AA8EF;;AA5EA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AA+EF;;AA7EA;EACE,iBAAA;AAgFF;;AA5EA;EACE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AA+EF;;AA3EA;EACE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AA8EF;;AA3EA;EACE,iBAAA;AA8EF;;AA5EA;EACE,iBAAA;AA+EF;;AA7EA;EACE,mBAAA;AAgFF;;AA7EA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,+CAAA;EAA4B,eAAA;AAmF7E;;AAjFA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,yBAAA;EAA0B,eAAA;AAuF3E;;AArFA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,iDAAA;EAA4B,eAAA;EAC3E,4BAAA;EACA,+BAAA;AA2FF;;AAzFA;EACE,mDAAA;EAA4B,kBAAA;EAAmB,iDAAA;EAA4B,eAAA;EAC3E,+BAAA;AA+FF;;AA7FA;EACE,+BAAA;AAgGF;;AA9FA;EACE,+BAAA;AAiGF;;AA/FA;EACE,yBAAA;AAkGF;;AAhGA;EACE,UAAA;EAAW,kBAAA;AAoGb;;AAlGA;EACE,UAAA;EAAW,gBAAA;AAsGb;;AApGA;EACE,cAAA;EAAgB,eAAA;EAAgB,eAAA;AAyGlC;;AAvGA;EACE,eAAA;EAAgB,kBAAA;AA2GlB;;AAxGA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;AA2GF;;AAzGA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AA4GF;;AA1GA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;AA6GF;;AA1GA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AA6GF;;AA3GA;EACE,oCAAA;EACA,sBAAA;EACA,iBAAA;AA8GF;;AA5GA;EACE,YAAA;AA+GF;;AA7GA;EACE,uBAAA;EACA,yBAAA;AAgHF;;AA7GA;EACE,0BAAA;EACA,2BAAA;AAgHF;;AA9GE;EACI,yBAAA;EACA,kCAAA;EACA,yBAAA;EACA,uBAAA;AAiHN;AA/GQ;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAiHV;AA/GQ;EACE,wBAAA;AAiHV;AA7GQ;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AA+GV;AA7GQ;EACE,wBAAA;AA+GV;;AA3GI;EACE,eAAA;EACA,uBAAA;EAEF,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AA6GJ;;AA3GI;EACE,eAAA;EACA,uBAAA;EAEF,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AA6GJ;;AA3GI;EACA,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACF,uBAAA;EACA,mBAAA;AA8GF;;AA3GI;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AA8GJ;;AA3GA;EACE,yBAAA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AA8GJ;;AA3GI;;EAEF,gBAAA;EACA,gBAAA;EACA,gBAAA;AA8GF;;AA3GA;EACE,aAAA;AA8GF;;AA3GA;EACE,gCAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AA8GF;;AA3GA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;AA8GF;;AA3GA;EACE,gBAAA;EACA,cAAA;AA8GF;;AA3GA;;;EAGE,cAAA;AA8GF;;AA3GA;;EAEE,mBAAA;AA8GF;;AA3GA;EACE,mBAAA;AA8GF;;AA5GA;EACE,iBAAA;EAAkB,iBAAA;EACnB,6BAAA;EAA8B,2BAAA;EAC7B,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AAiHF;;AA/GA;EACE,eAAA;EAAgB,YAAA;EAAa,kBAAA;AAoH/B;;AAlHA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AAqHF;;AAnHA;EACE,iBAAA;EAAkB,mBAAA;AAuHpB;;AArHA;EACE,eAAA;EACE,cAAA;EACA,YAAA;AAwHJ;;AAtHA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAyHA;;AAvHA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;AA0HF;;AAxHA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AA2HF;;AAzHA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AA4HF;;AA1HA;EACE,gBAAA;AA6HF;;AA3HA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AA8HA;;AA5HA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AA+HA;;AA7HA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAgIA;;AA9HA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAiIA;;AA/HA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAkIF;;AA/HA;EACE,gBAAA;EACF,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AAkIA;;AAhIA;EACE,kBAAA;AAmIF;;AAjIA;EACE,cAAA;AAoIF;;AAlIA;EAEE,6BAAA;EACA,2BAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iBAAA;EACA,iBAAA;AAoIF;;AAlIA;EACE,iBAAA;EAAkB,iBAAA;EAClB,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AAsIF;;AAnIA;EACE,6BAAA;EAA8B,2BAAA;EAC9B,iBAAA;EAAkB,iBAAA;AAwIpB;;AAtIA;EACE,yBAAA;EAA0B,eAAA;EAAgB,YAAA;EAAa,uBAAA;AA4IzD;;AAzIA;EACE,yBAAA;AA4IF;;AA1IA;EACE,YAAA;AA6IF;;AA3IA;EACE,yBAAA;AA8IF;;AA5IA;EACE,YAAA;EACA,uBAAA;AA+IF;;AA7IA;EACE,yBAAA;EAA0B,eAAA;EAAgB,YAAA;EAAa,uBAAA;EAAwB,eAAA;AAoJjF;;AAlJA;EACE,8BAAA;EACA,+BAAA;AAqJF;;AAnJA;EAIE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AAmJF;;AAhJA;EACE,6BAAA;AAmJF;;AAjJA;EACI,iBAAA;EACA,SAAA;EACA,kBAAA;AAoJJ;;AAlJA;EACE,uBAAA;EAAwB,YAAA;EAAa,eAAA;AAuJvC;;AArJA;EACE,qBAAA;EAAsB,YAAA;EAAa,eAAA;AA0JrC;;AAxJA;EACA,yBAAA;AA2JA;;AAzJA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AA4JF;;AA1JA;EACE,yBAAA;AA6JF;;AA3JA;EACE,uBAAA;EACA,oCAAA;EACA,eAAA;AA8JF;;AA5JA;EACE,yBAAA;EACA,YAAA;AA+JF;;AA5JA;EAGE,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AA6JF;;AAzJA;EAGE,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AA0JF;;AAtJA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,UAAA;EACA,eAAA;EACA,MAAA;AAyJF;;AAvJA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AA0JF;;AAxJA;EACE,uBAAA;AA2JF;;AAzJA;EACE,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AA4JF;;AA1JA;EACE,uBAAA;EACA,6BAAA;EAA8B,2BAAA;EAA4B,gBAAA;EAAgB,gBAAA;AAgK5E;;AA9JA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;AAiKF;;AA/JA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;EACA,qBAAA;EACA,YAAA;AAkKF;;AAhKA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;EACA,kCAAA;EACA,uBAAA;AAmKF;;AAjKA;EACE,4BAAA;EACA,4BAAA;EACA,0CAAA;AAoKF;;AAlKA;EACE,oCAAA;EACA,sBAAA;EACA,iBAAA;AAqKF;;AAlKA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AAqKF;;AAnKA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,yBAAA;EACA,mDAAA;EACA,iBAAA;EACA,iBAAA;AAsKF;;AApKA;EACE,eAAA;AAuKF;;AAlKA;EACE,4BAAA;EACA,4BAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAqKF;;AAnKA;EACE,cAAA;EACA,gCAAA;AAsKF;;AApKA;EACE,oCAAA;EACA,uBAAA;AAuKF;;AArKA;EACE,oCAAA;EACA,uBAAA;AAwKF;;AAtKA;EACE,4BAAA;EACA,4BAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAyKF;;AArKA;EACE,6BAAA;EACA,2BAAA;EACA,iBAAA;EACA,iBAAA;EACA,mDAAA;AAwKF;;AAtKA;EACE,gBAAA;EACA,UAAA;AAyKF;;AAvKA;EACE,6BAAA;EACA,0BAAA;AA0KF;;AArKA;EACE,eAAA;EAAgB,YAAA;EAAa,uBAAA;AA0K/B;;AAvKA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;AA0KF;;AAvKA;EACE,aAAA;AA0KF;;AAtKA;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAyKF;;AAtKA;EACE,gBAAA,EAAA,gCAAA;AAyKF;;AAvKA;EACE,yBAAA;AA0KF;;AAvKA;EACE,yBAAA;AA0KF;;AAxKA;;EAEE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA2KF;;AAxKA;EACE,UAAA;EACA,yBAAA;AA2KF;;AAxKA;EACE,YAAA;AA2KF;;AAxKA;EAEE,iBAAA;EACA,cAAA;AA0KF;;AAxKA;EACE,kBAAA;EACA,SAAA,EAAA,4DAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AA2KF;;AAvKA;EACE,cAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA0KF;;AAvKA;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;AA0KF;;AAxKA,yCAAA;AACA;EACE,aAAA,EAAA,gCAAA;EACA,kBAAA;AA2KF;;AAxKA;EACE,yBAAA,EAAA,4DAAA;AA2KF;;AAxKA;EACE,eAAA;AA2KF;;AAzKA;EACE,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AA4KF;;AA1KA;EACE,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;AA6KF;;AA3KA;EACE,yBAAA;AA8KF;;AA5KA;EACE,yBAAA;AA+KF;;AA7KA;EACE,yBAAA;AAgLF;;AA9KA;EACE,yBAAA;AAiLF;;AA/KA;EACE,yBAAA;AAkLF;;AAhLA;EACE,yBAAA;AAmLF;;AAjLA;EACE,yBAAA;AAoLF;;AAlLA;EACE,yBAAA;AAqLF;;AAnLA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAsLF;;AApLA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAuLA;;AArLA;EACE,mBAAA;EACA,eAAA;EACA,YAAA;AAwLF;;AAtLE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAyLJ;;AAvLE;EACE,4BAAA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AA0LN;;AAxLE;EACE,aAAA;AA2LJ;;AAzLA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AA4LF;AA3LE;EACE,WAAA;EACA,YAAA;AA6LJ;AA5LI;EACE,gCChmCM;EDimCN,oCCjmCM;AD+xCZ;AA5LI;EACE,YAAA;AA8LN;AA3LE;EACE,YAAA;EACA,WAAA;AA6LJ;;AA1LA;EACE,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AA6LF;;AA3LA;EACA,wBAAA;AA8LA;;AA3LA;EACE,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,aAAA;EACA,6BAAA;AA6LF;;AA1LA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AA6LF;;AA1LA;EACE,YAAA;EACA,eAAA;AA6LF;;AA1LA;EACE,yBAAA;AA6LF;;AA1LA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA6LF;;AA1LA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,oBAAA;AA6LF;;AA1LA;EACE,WAAA;EACA,YAAA;AA6LF;;AA1LA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,0BAAA;EACA,QAAA;EACA,0BAAA;AA6LF;;AAxKA;EACE,yBAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AA2KJ;;AAxKE;EACE,oCAAA;AA2KJ","sourcesContent":["@import \"/src/variables.scss\";\r\n\r\n.newciis{\r\n    font-family: Montserrat;\r\n}\r\n.excelimg{\r\n  margin-right: 4px;height: 15px;\r\n}\r\n.btn-outline-primary-custom {\r\n  color: #17a0b4 !important;\r\n  background-image: none !important;\r\n  background-color: transparent !important;\r\n  border-color: #17a0b4 !important;\r\n}\r\n.intheader{\r\n  font-size: 14px;padding-left: 2%;\r\n}\r\n.headercard{\r\n  height: 34px;border-radius: 2px;\r\n}\r\n.newintbtndiv{\r\n  padding-left: 6%;\r\n}\r\n.addicon{\r\n  font-size: 19px;height: fit-content;\r\n}\r\n.searchcard{\r\n  border-radius: 2px;  background-color: #ebebeb;font-size: 11px;\r\n}\r\n.proclabel{\r\n  padding-left: 10%;\r\n}\r\n.dircfieldcol{\r\n  padding-right:24px;\r\n}\r\n.btnsrcexp{\r\n  margin-top: 0%;padding-inline: 20%;margin-left: -17%;height: 27px !important;\r\n}\r\n.targetlabel{\r\n  padding-left: 10%;\r\n}\r\n.targetfieldcol{\r\n  padding-right: 24px;\r\n}\r\n.projlabeltrue{\r\n  padding-left: 12%;\r\n}\r\n\r\n.projfielddiv{\r\n  padding-right: 15px;\r\n}\r\n.listcard{\r\n  border-radius: 2px;\r\n}\r\n.todaylabel{\r\n  height: 26px;\r\n}\r\n.todaydivider{\r\n  background-color: rgb(10 87 117);height: 1px;\r\n}\r\n.yestlabel{\r\n  height: 28px;\r\n}\r\n.todayssuccessdivider{\r\n  background-color: green;height: 1px;\r\n}\r\n.todaysinprogdivider{\r\n  background-color: #73731d;height: 1px;\r\n}\r\n.todaysfaildivider{\r\n  background-color: #4e0c0c;height: 1px;\r\n}\r\n.desentity{\r\n  padding-left: 53px;\r\n}\r\n.modebtn{\r\n  height: 17px !important;line-height: 9px;\r\n}\r\n.pendingbtn{\r\n  height: 23px;\r\n}\r\n.pendingfileicon{\r\n  font-size: 18px;line-height: 14px;padding-right: 6px;height: auto;\r\n}\r\n.pendingdate{\r\n  padding-top:1px\r\n}\r\n.pendingcount{\r\n  padding-right: 1px;background-color: #ffd965;color: white;border-radius: 12px;\r\n}\r\n.pendingcountfail{\r\n  padding-right: 1px;background-color:red;color: white;border-radius: 12px;\r\n}\r\n.checklistdiv{\r\n  width:90%\r\n}\r\n.targetidslabel{\r\n  padding-left: 8%;\r\n}\r\n\r\n.vendorconlabel{\r\n  padding-left: 98px;\r\n}\r\n\r\n\r\n::ng-deep.failuremsgpop .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.failuremsgpop{\r\n  top: 4%!important;\r\n}\r\n.btn_stylenewint{\r\n  padding: 2px;\r\n  background-color: #00b050 !important;\r\n  font-size: 12px !important;\r\n  color: white !important;\r\n  height: 25px !important;\r\n  border-radius: 1px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n.btn_stylereset{\r\n  padding: 2px;\r\n  background-color: #ebebeb !important;\r\n  font-size: 12px !important;\r\n  color: black !important;\r\n  height: 25px !important;\r\n  border-radius: 1px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n.statusdiv{\r\n  padding-left: 4px;\r\n}\r\n::ng-deep .pipeline_feild .autocomplete-container{\r\n    box-shadow: none !important;\r\n    border-radius: 5px !important;\r\n    .input-container input{\r\n        border: 1px solid #C0C0C0 !important;\r\n        height: 28px !important;\r\n        width: 100% !important;\r\n    }\r\n    .input-container i{\r\n        line-height: 12px !important;\r\n    }\r\n   \r\n    .suggestions-container ul li a {\r\n        padding: 7px 13px !important;\r\n        display: block !important;\r\n        text-decoration: none !important;\r\n        cursor: pointer !important;\r\n        color: rgba(0, 0, 0, 0.87) !important;\r\n        font-size: 12px !important;\r\n    }\r\n}\r\n\r\n.datediv{\r\n    border: 1px solid #C0C0C0;\r\n    background-color: white;\r\n    border-radius: 5px;\r\n    height: 28px;\r\n}\r\n.datediv2{\r\n  border: 1px solid #C0C0C0;\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  width: 99%;\r\n  margin-left: 4px;\r\n}\r\n.fromspan{\r\npadding-right: 6px;\r\npadding-left: 9px;\r\nfont-size: 11px;\r\n}\r\n.frominput{\r\nborder: transparent;\r\nfont-size: 12px;\r\n}\r\n.tospan{\r\n    padding-right:3%;\r\n    font-size: 11px;\r\n}\r\n.tospanfail{\r\n  font-size: 11px;\r\n  padding-right: 1% !important;\r\n}\r\n.toinput{\r\nborder:transparent;\r\nfont-size: 12px;\r\n}\r\n.searchbtn{\r\n    margin-top: 7px;\r\n    width: 5%;\r\n    height: 26px !important;\r\n}\r\n.searchicon{\r\n    font-size: 16px !important;\r\n    line-height: 20px !important;\r\n}\r\n.searchdiv{\r\n    display: contents;\r\n}\r\n.leftcol{\r\nbackground-color: #f2f2f2;\r\nheight: 84vh;\r\n}\r\n.status{\r\n    width: 100%;\r\n    border-radius: 5px;\r\n    height: 26px;\r\n    font-size: 12px;\r\n    font-family: Montserrat;\r\n}\r\n.direction{\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  border: 1px solid #C0C0C0;\r\n  font-family: Montserrat;\r\n  option{\r\n    font-family: Montserrat;\r\n      padding: 7px 13px !important;\r\n      display: block !important;\r\n      text-decoration: none !important;\r\n      cursor: pointer !important;\r\n      color: rgba(0, 0, 0, 0.87) !important;\r\n      font-size: 12px !important;\r\n  }\r\n}\r\n.dateselect{\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  border: 1px solid #C0C0C0;\r\n  font-family: Montserrat;\r\n  background-color: #007887;\r\n  color: white;\r\n  option{\r\n    font-family: Montserrat;\r\n      padding: 7px 13px !important;\r\n      background-color: white;\r\n      display: block !important;\r\n      text-decoration: none !important;\r\n      cursor: pointer !important;\r\n      color: rgba(0, 0, 0, 0.87) !important;\r\n      font-size: 12px !important;\r\n  }\r\n}\r\n.dateselect2{\r\n  width: 80%;\r\n  border-radius: 5px;\r\n  height: 28px;\r\n  font-size: 12px;\r\n  border: 1px solid #C0C0C0;\r\n  font-family: Montserrat;\r\n  background-color: #007887;\r\n  color: white;\r\n  margin-left: 24px !important;\r\n  option{\r\n    font-family: Montserrat;\r\n      padding: 7px 13px !important;\r\n      background-color: white;\r\n      display: block !important;\r\n      text-decoration: none !important;\r\n      cursor: pointer !important;\r\n      color: rgba(0, 0, 0, 0.87) !important;\r\n      font-size: 12px !important;\r\n  }\r\n}\r\n    .rightcol{\r\n    background-color: white;\r\n    font-size: 12px;\r\n    }\r\n    .active_card {\r\n      border-left: 4px solid #07a36e;\r\n      width: 99%;\r\n    }\r\n    .active_cardcolor{\r\n      border-left: 4px solid #07a36e;\r\n      width: 99%;background-color: #C3EFF4;\r\n    }\r\n    .failed_card {\r\n      border-left: 4px solid #da606c;\r\n      width: 99%;\r\n    }\r\n    .failed_cardcolor {\r\n      border-left: 4px solid #da606c;\r\n      width: 99%;background-color: #C3EFF4;\r\n    }\r\n.active_img_inbound{\r\n  display: none;\r\n}\r\n.active_img{\r\n  display: none;\r\n}\r\n.inactive_img{\r\n  display: block;\r\n  margin-right: 9px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n.inactive_img_inbound{\r\n  display: block;\r\n  margin-right: 11px;\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n.displayNamediv{\r\n  padding-left: 6px;\r\n}\r\n.pipelinenamediv{\r\n}\r\n.pipelinenamediv:hover{\r\n  background-color: #3fa4fb;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  padding: 3px !important;\r\n  cursor: pointer;\r\n}\r\n.assignedUserNamediv{\r\n}\r\n.assignedUserNamediv:hover{\r\n  background-color: #3fa4fb;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  padding: 4px !important;\r\n}\r\n\r\n.modediv{\r\n  padding-left: 8px;\r\n}\r\n.routeIDdiv{\r\n  padding-left: 6px;\r\n}\r\n.transcountcol{\r\n  padding-inline: 7px;\r\n}\r\n\r\n.transcountsuccess{\r\n  background-color: #7dfb9340;padding-block: 1px;border: 1px solid #0080007d;font-size: 12px;\r\n}\r\n.transcountinprogress{\r\n  background-color: #fdf26659;padding-block: 1px;border: 1px solid #989024;font-size: 12px;\r\n}\r\n.transcountfailedto{\r\n  background-color: #ff80804d;padding-block: 1px;border: 1px solid #6f0f0f9c;font-size: 12px;\r\n  border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n.transcountfailedyes{\r\n  background-color: #ff80804d;padding-block: 1px;border: 1px solid #6f0f0f9c;font-size: 12px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n.detailsrouteid{\r\n  border-right: 2px solid #00bcd4;\r\n}\r\n.agents{\r\n  border-right: 2px solid #00bcd4;\r\n}\r\n.datesdiv{\r\n  background-color: #ebebeb;\r\n}\r\n.datedivsize{\r\n  width: 21%;padding-left: 31px;\r\n}\r\n.datedivsizemod{\r\n  width: 21%;padding-left: 6%;\r\n}\r\n.transadiv{\r\n  color: #17a0b4; font-size: 12px;margin-top: 3px;\r\n}\r\n.countdate{\r\n  font-size: 12px;margin-left: 103px;\r\n}\r\n\r\n.countdatediv{\r\n  width: 100px;\r\n  text-align: center;\r\n  border: 1px solid #e6e6e6;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  padding: 15px;\r\n  background-color: #ebebeb;\r\n}\r\n.successmsgheaders{\r\n  width: 100.3px;\r\n  text-align: center;\r\n  border: 1px solid #e6e6e6;\r\n  padding: 15px;\r\n  background-color: #ebebeb;\r\n  font-size: 12px;\r\n}\r\n.msgtitle{\r\n  font-size: 12px;\r\n  width: 100px;\r\n  border: 1px solid #e6e6e6;\r\n  text-align: left;\r\n  padding: 15px;\r\n}\r\n\r\n.msgcountdiv{\r\n  width: 100px;\r\n  text-align: center;\r\n  border: 1px solid #e6e6e6;\r\n  padding: 15px;\r\n}\r\n::ng-deep.directiontabs .mat-tab-group.mat-primary .mat-ink-bar {\r\n  background-color: #17a0b4 !important;\r\n  height: 4px !important;\r\n  margin-left: auto;\r\n}\r\n::ng-deep.directiontabs .mat-tab-header{\r\n  height: 33px;\r\n}\r\n::ng-deep.directiontabs .mat-tab-label{\r\n  height: 31px !important;\r\n  text-transform: uppercase;\r\n}\r\n\r\n::ng-deep.directiontabs .mat-tab-label .mat-tab-label-content{\r\n  font-size: 12px !important;\r\n  font-weight: 600 !important;\r\n}\r\n  ::ng-deep.directiontabs .mat-tab-label.mat-ripple.mat-tab-label-active {\r\n      color: #17a0b4 !important;\r\n      background-color: white !important;\r\n      opacity: unset !important;\r\n      font-family: Montserrat;\r\n      .outbound_style {\r\n        .active_img {\r\n          display: block !important;\r\n          margin-right: 9px;\r\n          position: relative;\r\n          top: -2px;\r\n        }\r\n        .inactive_img {\r\n          display: none !important;\r\n        }\r\n      }\r\n      .inbound_style {\r\n        .active_img_inbound {\r\n          display: block !important;\r\n          margin-right: 11px;\r\n          position: relative;\r\n          top: -2px;\r\n        }\r\n        .inactive_img_inbound {\r\n          display: none !important;\r\n        }\r\n      }\r\n    }\r\n    .directionlist{\r\n      font-size: 11px;\r\n      font-family: Montserrat;\r\n\r\n    min-height: 66vh !important;\r\n    max-height: 66vh !important;\r\n    overflow-x: hidden !important;\r\n    overflow-y: auto !important;\r\n    }\r\n    .directionlistexp{\r\n      font-size: 11px;\r\n      font-family: Montserrat;\r\n\r\n    min-height: 47vh !important;\r\n    max-height: 47vh !important;\r\n    overflow-x: hidden !important;\r\n    overflow-y: auto !important;\r\n    }\r\n    .dedisplayname{\r\n    color: #17a0b4;\r\n    font-weight: bold;\r\n    border-right: 2px solid #00bcd4;\r\n    overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n    }\r\n\r\n    .dividerline{\r\n    background-color: #17a0b4;\r\n    height: 3px;\r\n    width: 100%;\r\n    margin-top: 10px;\r\n    }\r\n\r\n.highchart{\r\n  border: 2px solid #007887;\r\n    font-size: 12px;\r\n    min-height: 280px;\r\n    max-height: 280px;\r\n    margin-left:4%;\r\n}\r\n\r\n    .highcharts-figure,\r\n.highcharts-data-table table {\r\n  min-width: 310px;\r\n  max-width: 310px;\r\n  margin: 1em auto;\r\n}\r\n\r\n#container {\r\n  height: 200px;\r\n}\r\n\r\n.highcharts-data-table table {\r\n  font-family: Verdana, sans-serif;\r\n  border-collapse: collapse;\r\n  border: 1px solid #ebebeb;\r\n  margin: 10px auto;\r\n  text-align: center;\r\n  width: 100%;\r\n  max-width: 300px;\r\n}\r\n\r\n.highcharts-data-table caption {\r\n  padding: 1em 0;\r\n  font-size: 1.2em;\r\n  color: #555;\r\n}\r\n\r\n.highcharts-data-table th {\r\n  font-weight: 600;\r\n  padding: 0.5em;\r\n}\r\n\r\n.highcharts-data-table td,\r\n.highcharts-data-table th,\r\n.highcharts-data-table caption {\r\n  padding: 0.5em;\r\n}\r\n\r\n.highcharts-data-table thead tr,\r\n.highcharts-data-table tr:nth-child(even) {\r\n  background: #f8f8f8;\r\n}\r\n\r\n.highcharts-data-table tr:hover {\r\n  background: #f1f7ff;\r\n}\r\n.failresbody{\r\n  min-height: 255px;max-height: 255px;\r\n overflow-x: hidden !important;overflow-y: auto !important;\r\n  border-bottom: 2px solid #007887;\r\n  border-left: 2px solid #007887;\r\n  border-right: 2px solid #007887;\r\n  border-radius: 2px;\r\n}\r\n.failrestitle{\r\n  font-size: 12px;color: white;border-radius: 2px;\r\n}\r\n.failres{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n.failresdiv{\r\n  margin-left: 25px;padding-right: 33px;\r\n}\r\n.lockicon{\r\n  font-size: 18px;\r\n    color: #ff5d00;\r\n    height: auto;\r\n}\r\n.ids{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 36%;\r\npadding-left: 4%;\r\n}\r\n.vendorids{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 35%;\r\n}\r\n.vendoridsmail{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 36%;\r\n  padding-left: 34px;\r\n}\r\n.vendoridsph{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 36%;\r\n  padding-left: 4%;\r\n}\r\n.vendormaillabel{\r\n  padding-left: 8%;\r\n}\r\n.idspop{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 36%;\r\npadding-left: 1%;\r\n}\r\n.idsproc{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 42%;\r\npadding-left: 40px;\r\npadding-right: 80px;\r\n}\r\n.idsproj{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 42%;\r\npadding-left: 7%;\r\n}\r\n.idslab{\r\noverflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 38%;\r\npadding-left: 77px;\r\npadding-right: 6%;\r\n}\r\n.pipelineidsdiv{\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  font-family: Montserrat;\r\n  width: 38%;\r\n  padding-right: 6%;\r\n  padding-left: 54px;\r\n\r\n  }\r\n.idsfac{\r\n  overflow: hidden;\r\ntext-overflow: ellipsis;\r\nwhite-space: nowrap;\r\nfont-size: 12px;\r\nfont-family: Montserrat;\r\nwidth: 34%;\r\npadding-left: 26px;\r\n}\r\n.projlabel{\r\n  padding-left: 28px;\r\n}\r\n.fontcolr{\r\n  color: #17a0b4;\r\n}\r\n.failresbodypop{\r\n  // min-height: 263px;max-height: 263px;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  border-bottom: 2px solid #007887;\r\n  border-left: 2px solid #007887;\r\n  border-right: 2px solid #007887;\r\n  min-height: 350px;\r\n  max-height: 350px;\r\n}\r\n.successresbody{\r\n  min-height: 255px;max-height: 255px;\r\n  border-bottom: 2px solid #007887;\r\n  border-left: 2px solid #007887;\r\n  border-right: 2px solid #007887;\r\n  border-radius: 2px;\r\n}\r\n\r\n.successreslist{\r\n  overflow-x: hidden !important;overflow-y: auto !important;\r\n  min-height: 232px;max-height: 232px;\r\n}\r\n.failurelistheader{\r\n  background-color: #007887;font-size: 12px;color: white;font-family: Montserrat;\r\n}\r\n\r\n::ng-deep.failresbodypop .mat-checkbox-frame{\r\n  border: 1px solid #007887;\r\n}\r\n::ng-deep.failresbodypop .mat-checkbox-inner-container {\r\n  height: 15px;\r\n}\r\n::ng-deep.failurelistheader .mat-checkbox-frame{\r\n  border: 1px solid #007887;\r\n}\r\n::ng-deep.failurelistheader .mat-checkbox-inner-container {\r\n  height: 15px;\r\n  background-color: white;\r\n}\r\n.reprobtn{\r\n  background-color: #007887;font-size: 12px;color: white;font-family: Montserrat;cursor: pointer;\r\n}\r\n.popupdate{\r\n  border-left: 2px solid #00bcd4;\r\n  border-right: 2px solid #00bcd4;\r\n}\r\n.reason{\r\n  // overflow: hidden;\r\n  // text-overflow: ellipsis;\r\n  // white-space: nowrap;\r\n  font-size: 13px;\r\n  color: #17a0b4;\r\n  font-weight: bold;\r\n  font-family: Montserrat;\r\n  // width: 23%;\r\n}\r\n.headercheckbox{\r\n  padding-left: calc(1vw + 3px);\r\n}\r\n.chevronleft{\r\n    line-height: 36px;\r\n    top: 14px;\r\n    position: relative;\r\n}\r\n.chevronleftbtnact{\r\n  background-color: green;color: white;margin-left: 1%;\r\n}\r\n.chevronleftbtninact{\r\n  background-color: red;color: white;margin-left: 1%;\r\n}\r\n.failresheader{\r\nbackground-color: #007887;\r\n}\r\n.countdateheader{\r\n  background-color: #007887;\r\n  height: 22px;\r\n  width: 100%;\r\n  margin-left: 0px;\r\n}\r\n.modal .modalsize{\r\n  max-width: 90% !important;\r\n}\r\n::ng-deep.idsexpdiv .idsacc .mat-expansion-panel-body {\r\n  padding: 5px !important;\r\n  background-color: #ebebeb !important;\r\n  font-size: 12px;\r\n}\r\n.msgcountday{\r\n  background-color: #17a2b8;\r\n  color: white;\r\n}\r\n\r\n.main {\r\n  // top: 26%;\r\n  //   left: 13%;\r\n  height: 17px;\r\n  border-radius: 0 0 100px 100px;\r\n  border: 1px solid grey;\r\n  border-top: none;\r\n  background-clip: padding-box;\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-right: 6px;\r\n  padding-inline: 3px;\r\n  position: relative;\r\n  top: 9px;\r\n  // padding-bottom: 3px;\r\n}\r\n\r\n.submain {\r\n  // top: 26%;\r\n  // left: 13%;\r\n  height: 17px;\r\n  border-radius: 0 0 100px 100px;\r\n  border: 1px solid grey;\r\n  border-top: none;\r\n  background-clip: padding-box;\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-right: 6px;\r\n  padding-inline: 3px;\r\n  position: relative;\r\n  top: 9px;\r\n  // padding-bottom: 3px;\r\n}\r\n\r\n.main::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 100%;\r\n  right: 1px;\r\n  height: 1px;\r\n  border-top: 1px solid grey;\r\n  width: 33%;\r\n  display: inline;\r\n  top: 0;\r\n}\r\n.img_space {\r\n  height: 23px;\r\n  position: relative;\r\n  top: -12px;\r\n}\r\n.varulebtn{\r\n  height: 23px !important;\r\n}\r\n.connheadersdef{\r\n  bottom: 7%;\r\n  position: relative;\r\n  background-color: #ebebeb;\r\n  color: black;\r\n  border: 1px solid;\r\n  border-radius: 1px;\r\n  left: 14%;\r\n  width: 70%;\r\n}\r\n.details2{\r\n  background-color: white;\r\n  overflow-x: hidden !important;overflow-y: auto !important;min-height:64vh;max-height: 64vh;\r\n}\r\n::ng-deep.connec .mat-tab-label{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n}\r\n::ng-deep.interface .Failed{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n  background-color: red ;\r\n  color: white;\r\n}\r\n::ng-deep.connec .Success.mat-tab-label{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n  background-color: green !important;\r\n  color: white !important;\r\n}\r\n::ng-deep.connec .default .mat-tab-label{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border-right: 2px solid #ebebeb !important;\r\n}\r\n::ng-deep.connec .mat-tab-group.mat-primary .mat-ink-bar {\r\n  background-color: #17a0b4 !important;\r\n  height: 4px !important;\r\n  margin-left: auto;\r\n}\r\n\r\n.stepper-wrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: 82vh;\r\n  overflow-x: hidden;\r\n}\r\n.stepper-item {\r\n  position: relative;\r\n  font-size: 11px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  flex: 1;\r\n  background-color: #ebebeb;\r\n  border: 2px solid #c8c5c538;\r\n  min-width: 16.66%;\r\n  max-width: 16.66%;\r\n}\r\n.cursor {\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n\r\n.seqheader{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border: 2px solid #ebebeb !important;\r\n  height: 33px;\r\n  padding: 5px;\r\n  text-align: center;\r\n  opacity: 0.5;\r\n}\r\n.seqheaderActive{\r\n  opacity: unset;\r\n  box-shadow: 1px 0px 7px 1px grey;\r\n}\r\n.Failed{\r\n  background-color:#f59598 !important;\r\n  color: white !important;\r\n}\r\n.Success{\r\n  background-color:#90cfb5 !important;\r\n  color: white !important;\r\n}\r\n.default{\r\n  min-width: 16.66% !important;\r\n  max-width: 16.66% !important;\r\n  border: 2px solid #ebebeb !important;\r\n  height: 33px;\r\n  padding: 5px;\r\n  text-align: center;\r\n  opacity: 0.5;\r\n}\r\n\r\n\r\n.seqbody{\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  min-height:120px;\r\n  max-height: 120px;\r\n  background-color: #a9dad152;\r\n}\r\n.datediviconsize{\r\n  padding-left: 4%;\r\n  width: 14%;\r\n}\r\n.form-control{\r\n  border-radius: 5px !important;\r\n  font-size: 11px !important;\r\n}\r\n\r\n//Datavalidation style part\r\n\r\n.failurelistheader1{\r\n  font-size: 12px;color: black;font-family: Montserrat;\r\n}\r\n\r\n.mat-mdc-table {\r\n  width: 100%;\r\n  max-height: 100px;\r\n  overflow: auto;\r\n}\r\n\r\n.mat-column-name {\r\n  height: 100px;\r\n}\r\n\r\n\r\n.datavalidtableheader {\r\n  position: sticky;\r\n  top: 0;\r\n  background-color:#0e6470;\r\n  z-index: 1;\r\n  color: white;\r\n  height: 23px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.content-row {\r\n  margin-top: 30px; /* Adjust the margin as needed */\r\n}\r\n.even-row {\r\n  background-color: #F0F0F0;\r\n}\r\n\r\n.odd-row {\r\n  background-color: #FFFFFF;\r\n}\r\n.even-row,\r\n.odd-row {\r\n  height: 33px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.container::-webkit-scrollbar {\r\n  width: 8px;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.mat-form-field-appearance-outline .mat-form-field-infix {\r\n  width: 221px;\r\n}\r\n\r\n.callsplit\r\n{\r\n  margin-right: 5px;\r\n  color:#f44455;\r\n}\r\n.scrollable-content {\r\n  position: absolute;\r\n  top: 20px; /* Adjust this value to match the height of the sticky row */\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  overflow-x: hidden;\r\n  //background-color: royalblue;\r\n}\r\n\r\n::ng-deep .ValidationPopupScreen .modal-dialog {\r\n  max-width: 80%;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n.Header_row{\r\n  background:#007887; \r\n  margin-inline: -0.5px; \r\n  color: white\r\n}\r\n/* Add the styles for the scrolling div */\r\n.card-scroll {\r\n  height: 387px; /* Adjust the height as needed */\r\n  overflow-x: hidden;\r\n}\r\n\r\n.selected{\r\n  background-color: #B8FAFF; /* Add your desired background color for the selected card */\r\n}\r\n\r\n.isCompletedStatus {\r\n  cursor: pointer;\r\n}\r\n.visibility_off{\r\n  color: #17a2b8;\r\n  height: 19px !important;\r\n  width: 19px !important;\r\n  font-size: 19px;\r\n  padding-left: 13px;\r\n  position: relative;\r\n  top: 1px;\r\n  cursor: pointer; \r\n}\r\n.visibility{\r\n  color: #17a2b8;\r\n  height: 19px !important;\r\n  width: 19px !important;\r\n  font-size: 19px;\r\n  cursor: pointer;\r\n}\r\n.failrow .msgtitle{\r\n  background-color: #ffc3c3;\r\n}\r\n.failrow .msgcountdiv{\r\n  background-color: #ffc3c3;\r\n}\r\n.ignorerow .msgtitle{\r\n  background-color: #fffdbe;\r\n}\r\n.ignorerow .msgcountdiv{\r\n  background-color: #fffdbe;\r\n}\r\n.successrow .msgtitle{\r\n  background-color: #c4fba0;\r\n}\r\n.successrow .msgcountdiv{\r\n  background-color: #c4fba0;\r\n}\r\n.resolvedrow .msgtitle{\r\n  background-color: #c6ecff;\r\n}\r\n.resolvedrow .msgcountdiv{\r\n  background-color: #c6ecff;\r\n}\r\n.datedivpop{\r\n  border: 1px solid #C0C0C0;\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  height: 24px;\r\n  width: 47%;\r\n}\r\n.toinputpop{\r\nborder:transparent;\r\nfont-size: 12px;\r\nheight: 20px;\r\n}\r\n.frominputpop{\r\n  border:transparent;\r\n  font-size: 12px;\r\n  height: 20px;\r\n  }\r\n  .datesearchpopbtn{\r\n    background-color: #59a7b1;\r\n    color: white;\r\n    height: 24px;\r\n    width: 28px;\r\n    padding-left: 1px;\r\n  }\r\n  .copy_iconss{\r\n    background-repeat: no-repeat;\r\n      display: inline-block;\r\n      fill: currentColor;\r\n      font-size: 16px;\r\n      position: relative;\r\n      top: 8%;\r\n      left: 2%;\r\n      cursor: pointer;\r\n  }\r\n  .mat-icon-button ::ng-deep .mat-button-focus-overlay {\r\n    display: none;\r\n}\r\n::ng-deep.myint.mat-mdc-checkbox {\r\n  height: 16px;\r\n  width: 16px;\r\n  position: relative;\r\n  right: 100%;\r\n  bottom: 42%;\r\n  .mdc-checkbox {\r\n    width: 14px;\r\n    height: 14px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n}\r\n.msgmodaldata{\r\n  min-height: 65vh !important;\r\n  max-height: 68vh  !important;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto  !important;\r\n}\r\n::ng-deep.moreicon .mat-mdc-button-persistent-ripple{\r\ndisplay: none !important;\r\n}\r\n\r\n.autocomplete-dropdown {\r\n  position: absolute;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  // width: 119vh;\r\n  z-index: 1000;\r\n  border-radius: 6px !important;\r\n}\r\n\r\n.autocomplete-dropdown ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: black;\r\n}\r\n\r\n.autocomplete-dropdown li {\r\n  padding: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.autocomplete-dropdown li:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.loading-spinner {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 10px; \r\n  transform: translateY(-50%);\r\n  pointer-events: none; \r\n}\r\n\r\n.mat-spinner {\r\n  width: 20px;  \r\n  height: 20px;\r\n}\r\n\r\n.clear-icon {\r\n  position: absolute;\r\n  right: 0%;\r\n  cursor: pointer;\r\n  color: rgba(0, 0, 0, 0.54);\r\n  top: 20%;\r\n  font-size: 18px !important;\r\n}\r\n\r\n// .loading-spinner {\r\n//   display: flex;\r\n//   align-items: center;\r\n//   margin-top: 5px;\r\n//   font-size: 14px;\r\n//   color: #888;\r\n// }\r\n\r\n// .successborder {\r\n//   color: green;\r\n// }\r\n\r\n// .dangerborder {\r\n//   color: red;\r\n// }\r\n.redirectlink{\r\n\r\n}\r\n.redirectlink:hover{\r\n  background-color: #3fa4fb;\r\n    border-radius: 12px;\r\n    color: white;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n    height: 21px;\r\n}\r\n.interfacepagination{\r\n  .mat-mdc-paginator{\r\n    background-color: #f1f1f1 !important;\r\n  }\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
